import { InvoiceDraftRowViewModel } from 'viewModels/invoice/InvoiceDraftRowViewModel';

export default class ShipmentDraftPricesResponseViewModel {
  sales: InvoiceDraftRowViewModel[];
  purchase: InvoiceDraftRowViewModel[];

  salesInvoiceId: string;
  salesInvoiceNumber: string;
}
